// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WishLists-createIcon-PS2zh{
    width: 16px;
}
.WishLists-flexColumn-L3qsP{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
}`, "",{"version":3,"sources":["webpack://./src/components/WishLists/WishLists.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,mBAAe;QAAf,eAAe;AACnB","sourcesContent":[".createIcon{\n    width: 16px;\n}\n.flexColumn{\n    display: flex;\n    flex-wrap: wrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createIcon": `WishLists-createIcon-PS2zh`,
	"flexColumn": `WishLists-flexColumn-L3qsP`
};
module.exports = ___CSS_LOADER_EXPORT___;
